import React from 'react';
import GetIcon from '../../../../utils/Icon';
import Input from '../../../../Core/Fields/Floating/Input';

function Tab2({ deliveryNoteData }) {
  const formatAddress = (address) => {
    return address?.replace(/<br\s*\/?>/gi, '\n').trim() || '';
  };

  return (
    <div className="row m-0" style={{ padding: "8px", borderRadius: "5px" }}>
      <div className="col-12">
        <div className="tableLabel">
          <p className="mb-1" style={{ color: "#391F84", fontWeight: '500' }}>Billing Address</p>
          <div style={{ width: '99.5%', borderBottom: '1px solid #caced3', marginBottom: '15px' }}></div>
        </div>
      </div>

      <div className="col-md-4 mt-0">
        <Input
          id="BillingAddress"
          label="Billing Address Name"
          value={formatAddress(deliveryNoteData?.customer_address)}
          readOnly
          style={{ fontSize: '0.8rem', height: '30px', whiteSpace: 'pre-line' }}
        />
      </div>

      <div className="col-md-4 mt-0">
        <Input
          id="CustomerContact"
          label="Customer Contact"
          value=""
          readOnly
          style={{ fontSize: '0.8rem', height: '30px' }}
        />
      </div>

      <div className="col-md-4 mt-0">
        <Input
          id="GSTCategory"
          label="GST Category"
          value={deliveryNoteData?.gst_category || ''}
          readOnly
          style={{ fontSize: '0.8rem', height: '30px' }}
        />
      </div>

      <div className="col-12 mt-3">
        <div className="tableLabel">
          <p className="mb-1" style={{ color: "#391F84", fontWeight: '500' }}>Shipping Address</p>
          <div style={{ width: '99.5%', borderBottom: '1px solid #caced3', marginBottom: '15px' }}></div>
        </div>
      </div>

      <div className="col-md-4 mt-0">
        <Input
          id="ShippingAddress"
          label="Shipping Address"
          value={formatAddress(deliveryNoteData?.shipping_address)}
          readOnly
          style={{ fontSize: '0.8rem', height: '30px', whiteSpace: 'pre-line' }}
        />
      </div>

      <div className="col-md-4 mt-0 mb-5">
        <Input
          id="DispatchAddress"
          label="Dispatch Address Name"
          value=" "
          readOnly
          style={{ fontSize: '0.8rem', height: '30px' }}
        />
      </div>

      <div className="col-md-4 mt-0">
        <Input
          id="CompanyBillingAddress"
          label="Company Billing Address"
          value={formatAddress(deliveryNoteData?.address_display)}
          readOnly
          style={{ fontSize: '0.8rem', height: '30px', whiteSpace: 'pre-line' }}
        />
      </div>
    </div>
  );
}

export default Tab2;
